import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import "../styles/modalPolitics.css";

export default function ModalConduct() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <a onClick={handleClickOpen} className={"enlaceToPolitic"}>
        Reporte de sospecha de mala conducta FRANCA® Agency
      </a>
      <Dialog
        open={open}
        fullWidth={true}
        maxWidth={"lg"}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <img
                    src="/assets/franca_logo_politics.png"
                    alt=""
                    style={{ width: "25%" }}
                  />
                </div>
                <br />

                <h4 style={{ textAlign: "center" }}>
                  <b>Reporte de sospecha de mala conducta FRANCA® Agency</b>
                </h4>
              </div>
            </div>
            <br />
            En FRANCA® Agency, promovemos una cultura de integridad, respeto y
            cumplimiento. Por eso, ponemos a disposición este canal para que
            cualquier colaborador o interesado pueda reportar, de manera
            confidencial, cualquier sospecha de conducta indebida que atente
            contra nuestros valores, políticas internas o la ley.
            <br />
            <br />
            <h5>
              <b>¿Quién recibe estos reportes?</b>
            </h5>
            El Área Administrativa será la encargada de recibir y registrar
            todos los reportes de mala conducta. Según la naturaleza del caso,
            este será escalado al área correspondiente para su revisión e
            investigación.
            <br />
            <br />
            <h5>
              <b>¿Qué se puede reportar?</b>
            </h5>
            <ul>
              <li>
                Este canal está diseñado para recibir reportes relacionados con:
              </li>
              <li>
                Conductas contrarias al código de ética o a los valores
                corporativos.
              </li>
              <li>Mal uso de recursos de la empresa.</li>
              <li>Conflictos de interés no declarados.</li>
              <li>Discriminación, acoso laboral o cualquier trato injusto.</li>
              <li>Falsificación de documentos o fraude.</li>
              <li>Violaciones graves de políticas internas.</li>
              <li>
                Otros hechos que representen un riesgo legal, reputacional o de
                cumplimiento.
              </li>
              <li>
                Este canal no debe usarse para reportar inconformidades menores
                o reclamos generales de desempeño o clima laboral. Para esos
                casos, se recomienda acudir a Talento Humano o a su jefe
                directo.
              </li>
            </ul>
            <br />
            <h5>
              <b>¿Cómo realizar un reporte?</b>
            </h5>
            Puede enviar su reporte por cualquiera de los siguientes medios:
            Correo electrónico: hola@franca.agency, formato físico: disponible en
            el Área Administrativa Buzón, confidencial: ubicado en [ubicación
            física]. Puede optar por identificarse o realizar el reporte de forma
            anónima. Sin embargo, incluir su nombre y datos de contacto puede
            facilitar una investigación más completa y efectiva.
            <br />
            <br />
            <h5>
              <b>Confidencialidad y protección</b>
            </h5>
            Todos los reportes serán tratados con la máxima confidencialidad. La
            empresa no tolerará represalias contra quienes, de buena fe,
            reporten una situación irregular o participen en una investigación.
            <br />
            <br />
            <h5>
              <b>Seguimiento</b>
            </h5>
            En caso de identificarse, se le podrá brindar información sobre el
            avance del caso, siempre que no comprometa la confidencialidad del
            proceso. Si el reporte fue anónimo, la empresa garantizará que se
            tomen las medidas necesarias con base en la información disponible.
            <br />
            <br />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="error">
            Cerrar
          </Button>
          {/* <Button onClick={handlePolitics} color="success" autoFocus>
            Aceptar
          </Button> */}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
